<template>
    <div class="card border-0 card-with-shadow">
        <div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">
            <h5 v-show="isDetailsEditable" class="card-title text-muted mb-0">{{ $t('details') }}</h5>
            <h5 v-show="!isDetailsEditable" class="card-title text-muted mb-0">{{$t('edit_details')}}</h5>
            <div>
                <a href="#" v-show="!isDetailsEditable" class="text-muted" @click.prevent="showDetailsHide">
                    <app-icon stroke-width="1" name="x-square"/>
                </a>
                <a href="#" v-show="!isDetailsEditable" class="text-muted" @click.prevent="showDetailsSave">
                    <app-icon stroke-width="1" name="check-square"/>
                </a>
                <a href="#" v-show="isDetailsEditable" class="text-muted" @click.prevent="showDetailsEditable">
                    <app-icon stroke-width="1" name="edit"/>
                </a>
            </div>
        </div>
        <div class="card-body">
            <div v-show="isDetailsEditable">
                <div class="form-group mb-3">
                    <div class="form-row">
                        <label class="mb-0 text-muted col-3 d-flex align-items-center">
                            {{ $t('name') }}
                        </label>
                        <div class="col-9">
                            {{detailsData.name}}
                        </div>
                    </div>
                </div>
                <div class="form-group mb-3">
                    <div class="form-row">
                        <label class="mb-0 text-muted col-3 d-flex align-items-center">
                            {{ $t('type') }}
                        </label>
                        <div class="col-9" v-if="detailsData.contact_type">
                            <app-badge :label="detailsData.contact_type.name"
                                       :className="`badge-sm badge-pill badge-${detailsData.contact_type.class}`"/>
                        </div>
                    </div>
                </div>
                <div class="form-group mb-0">
                    <div class="form-row">
                        <label class="mb-0 text-muted col-3 d-flex align-items-center">
                            {{ $t('owner') }}
                        </label>
                        <div class="col-9">
                            <div class="d-flex align-items-center" v-if="detailsData.owner">
                                <app-avatar class="mr-2"
                                            :title="detailsData.owner.full_name"
                                            :avatar-class="'avatars-w-30'"
                                            :img="detailsData.owner.profile_picture ?
                                             urlGenerator(detailsData.owner.profile_picture.path) :
                                             detailsData.owner.profile_picture"/>
                                <span>{{detailsData.owner.full_name}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="!isDetailsEditable">
                <div class="form-group mb-3">
                    <div class="form-row">
                        <label class="col-3 mb-0 d-flex align-items-center">{{$t('name')}}</label>
                        <div class="col-9">
                            <app-input type="text"
                                       v-model="detailsData.name"/>
                        </div>
                    </div>
                </div>
                <div class="form-group mb-3">
                    <div class="form-row">
                        <label class="col-3 mb-0 d-flex align-items-center">{{$t('type')}}</label>
                        <div class="col-9">
                            <app-input type="select"
                                       :list="contentTypeList"
                                       list-value-field='name'
                                       v-model="detailsData.contact_type_id"/>
                        </div>
                    </div>
                </div>
                <div class="form-group mb-0">
                    <div class="form-row">
                        <label class="col-3 mb-0 d-flex align-items-center">{{$t('owner')}}</label>
                        <div class="col-9">
                            <app-input type="select"
                                       list-value-field='full_name'
                                       :list="ownerList"
                                       v-model="detailsData.owner_id"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {FormMixin} from "@core/mixins/form/FormMixin.js";
    import {mapGetters} from 'vuex';
    import {urlGenerator} from "@app/Helpers/helpers";

    export default {
        name: "DetailsPerson",
        props: ['detailsData'],
        mixins: [FormMixin],
        data() {
            return {
                urlGenerator,
                isDetailsEditable: true,
                formData: {},
            }
        },
        computed: {
            ...mapGetters({
                ownerList: 'getOwner',
                contentTypeList: 'contentType'
            })
        },
        methods: {
            showDetailsHide() {
                this.isDetailsEditable = true;
            },
            showDetailsEditable() {
                this.isDetailsEditable = false
            },
            showDetailsSave() {
                this.formData.name = this.detailsData.name;
                this.formData.contact_type_id = this.detailsData.contact_type_id;
                this.formData.owner_id = this.detailsData.owner_id;
                this.axiosPatch({
                    url: `crm/persons/${this.detailsData.id}`,
                    data: this.formData
                }).then((response) => {
                    this.afterSuccess(response);
                })
            },
            afterSuccess(response){
                this.$toastr.s(response.data.message);
                this.isDetailsEditable = true
                this.$emit('update-request')
            }
        },
        mounted(){
            this.$store.dispatch('getOwner');
            this.$store.dispatch('contentType');
        }
    }
</script>

